import Handlebars from 'handlebars';

export function registerHandlebarsHelpers(handlebars) {
    handlebars.registerHelper('trimString', (value, startstring, endstring) => {
        if (!value) return value;
        const theString = value.substring(startstring, endstring);
        return new Handlebars.SafeString(theString);
    });

    handlebars.registerHelper('roundNumber', (value) => {
        if (!value) return value;
        return Math.round(value);
    });

    handlebars.registerHelper('math', (lvalue, operator, rvalue) => {
        lvalue = parseFloat(lvalue);
        rvalue = parseFloat(rvalue);
        switch (operator) {
            case '+': return lvalue + rvalue;
            case '-': return lvalue - rvalue;
            case '*': return lvalue * rvalue;
            case '/': return lvalue / rvalue;
            case '%': return lvalue % rvalue;
            default: return lvalue;
        }
    });

    handlebars.registerHelper('convertRatingToClass', (rating) => {
        const starRating = rating ? Math.round(rating * 2) / 2 : 0;
        return 'vup-product-stars-' + String(starRating).replace('.', '-');
    });

    handlebars.registerHelper('random', (min, max) => {
        return Math.round((Math.random() * (max - min)) + min);
    });

    return handlebars;
}

export function createWithHelpers() {
    return registerHandlebarsHelpers(Handlebars.create());
}

export function compileHandlebarsTemplate(handlebars, templateText) {
    if (templateText) {
        return handlebars.compile(templateText);
    }
    return null;
}

export function registerHandlebarsPartial(handlebars, name, template) {
    if (name && template) {
        handlebars.registerPartial(name, template);
    }
}

// default instance
export default createWithHelpers();